import { render, staticRenderFns } from "./SinglePermissions.vue?vue&type=template&id=70374413&"
import script from "./SinglePermissions.vue?vue&type=script&lang=js&"
export * from "./SinglePermissions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports